import { LockIcon } from 'lucide-react';

import { cn } from '@crossnokaye/ux-common';

import type { LegendItem } from './sequencer-legend';

/** Standard legend items shared across all sequencer table variants. */
export const standardLegendItems: LegendItem[] = [
  {
    icon: <LockIcon className={cn('glyph glyph-sm stroke-muted-foreground')} />,
    label: 'Unavailable',
  },
  {
    icon: <div className="w-4 h-4 bg-muted rounded-full border border-muted-foreground" />,
    label: 'Off',
  },
  {
    icon: <div className="w-4 h-4 bg-primary rounded-full" />,
    label: 'On',
  },
];

/** Active stage indicator used by sequencer tables. */
export const activeStageLegendItem: LegendItem = {
  icon: <div className="w-4 h-4 bg-ckds-base-white rounded-full border border-border" />,
  label: 'Active Stage',
};
